import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { openModal } from '@/redux/modal';

// Services
import formatPrice from '../services/formatPrice';

// Components
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import ButtonExpand from './shared/buttons/ButtonExpand';
import HouseIconsMap from './shared/designElements/HouseIconsMap';
import WishlistFooter from './shared/designElements/WishlistFooter';
import AlertIcon from './shared/icons/Alert';
import ConfirmedOrdersDownload from './ConfirmedOrdersDownload';
import ExternalSeller from './molecules/ExternalSeller';
import { OptionSubtitleContainer } from './organisms/Option';

// Styles
import { colorPalette, colorPaletteRGB, fonts } from '@/styles/styleGuide';
import { fromBreakpoint, toBreakpoint } from '@/styles/breakpoints';
import withMatch from '@/hocs/withMatch';
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openConfirmModal: function openConfirmModal(orderId) {
      dispatch(openModal(colorPalette.blue, {
        type: 'orderConfirm',
        componentProps: {
          projectSlug: String(ownProps.match.params.projectSlug),
          orderId: orderId,
          categories: ownProps.categories,
          houseOverviewTotalPerCompany: ownProps.houseOverviewTotalPerCompany
        }
      }));
    },
    openStatusModal: function openStatusModal(orderId) {
      dispatch(openModal(colorPalette.blue, {
        type: 'optionOrderStatus',
        componentProps: {
          projectSlug: String(ownProps.match.params.projectSlug),
          orderId: orderId
        }
      }));
    }
  };
};
var MyHouseChoices = /*#__PURE__*/function (_PureComponent) {
  function MyHouseChoices() {
    var _this;
    _classCallCheck(this, MyHouseChoices);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MyHouseChoices, [].concat(args));
    _defineProperty(_this, "calculateTotalPrice", function (categories, price) {
      if (!categories) return;
      return categories.reduce(function (categoryAcc, category) {
        return categoryAcc + category.orders.reduce(function (ordersAcc, order) {
          return ordersAcc + order.salesPrice * order.amount;
        }, 0);
      }, price || 0);
    });
    _defineProperty(_this, "hasExternalSellers", function (houseOverviewTotalPerCompany) {
      if (!houseOverviewTotalPerCompany) return false;
      return houseOverviewTotalPerCompany.length > 1;
    });
    _defineProperty(_this, "transformLastUpdateDate", function (date) {
      var dateParts = date.split(/-| /);
      return "(".concat(dateParts[2], "-").concat(dateParts[1], "-").concat(dateParts[0], ")");
    });
    _defineProperty(_this, "handleConfirmModal", function (orderId) {
      var openConfirmModal = _this.props.openConfirmModal;
      if (typeof openConfirmModal === 'function') {
        openConfirmModal(orderId);
      }
    });
    _defineProperty(_this, "handleStatusModal", function (orderId) {
      var openStatusModal = _this.props.openStatusModal;
      if (typeof openStatusModal === 'function') {
        openStatusModal(orderId);
      }
    });
    return _this;
  }
  _inherits(MyHouseChoices, _PureComponent);
  return _createClass(MyHouseChoices, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        _this$props$categorie = _this$props.categories,
        categories = _this$props$categorie === void 0 ? [] : _this$props$categorie,
        bnr = _this$props.bnr,
        price = _this$props.price,
        renderWidth = _this$props.renderWidth,
        livingSpace = _this$props.livingSpace,
        bedrooms = _this$props.bedrooms,
        houseConfirmationExport = _this$props.houseConfirmationExport,
        houseOverviewTotalPerCompany = _this$props.houseOverviewTotalPerCompany;
      var totalPrice = this.calculateTotalPrice(categories, price);
      var hasExternalSellers = this.hasExternalSellers(houseOverviewTotalPerCompany);
      return __jsx(MyHouseChoicesContainer, {
        "data-id": "components_MyHouseChoices_MyHouseChoicesContainer"
      }, __jsx(Title, {
        "data-id": "components_MyHouseChoices_Title"
      }, "Mijn keuzes"), __jsx(Choices, {
        "data-id": "components_MyHouseChoices_Choices"
      }, __jsx(Base, {
        "data-id": "components_MyHouseChoices_Base"
      }, __jsx(CategoryTitleContainer, {
        "data-id": "components_MyHouseChoices_CategoryTitleContainer"
      }, __jsx(HouseIconsMap, {
        icon: "houseEmpty",
        color: colorPalette.lightOrange,
        "data-id": "components_MyHouseChoices_HouseIconsMap"
      }), __jsx(CategoryTitle, {
        "data-id": "components_MyHouseChoices_CategoryTitle"
      }, "Basisprijs")), __jsx(Order, {
        "data-id": "components_MyHouseChoices_Order"
      }, __jsx(OrderContainer, {
        "data-id": "components_MyHouseChoices_OrderContainer"
      }, __jsx(OrderTitle, {
        "data-id": "components_MyHouseChoices_OrderTitle"
      }, "Bouwnummer ", bnr), renderWidth > 689 && __jsx(OrderPrice, {
        "data-id": "components_MyHouseChoices_OrderPrice"
      }, formatPrice(price, {
        showDecimal: true,
        showEuroSign: true,
        showNegative: false
      }))), renderWidth <= 689 && __jsx(OrderPrice, {
        "data-id": "components_MyHouseChoices_OrderPrice_11"
      }, formatPrice(price, {
        showDecimal: true,
        showEuroSign: true,
        showNegative: false
      })))), (categories || []).map(function (cat, i) {
        return __jsx(Category, {
          key: i,
          "data-id": "components_MyHouseChoices_Category"
        }, __jsx(CategoryTitleContainer, {
          firstStatus: cat.orders.length > 0 && cat.orders[0].place,
          "data-id": "components_MyHouseChoices_CategoryTitleContainer"
        }, __jsx(HouseIconsMap, {
          icon: cat.icon,
          color: colorPalette.lightOrange,
          "data-id": "components_MyHouseChoices_HouseIconsMap"
        }), __jsx(CategoryTitle, {
          "data-id": "components_MyHouseChoices_CategoryTitle"
        }, cat.title)), (cat.orders || []).map(function (order, index) {
          var updateDate = _this2.transformLastUpdateDate(order.lastUpdate);
          var handleConfirm = function handleConfirm() {
            return _this2.handleConfirmModal(order.id);
          };
          var handleStatus = function handleStatus() {
            return _this2.handleStatusModal(order.id);
          };
          return order.place !== 'blocked' && order.place !== 'cancelled' && order.place !== 'cancelled-postsale' && __jsx(Order, {
            key: index,
            className: "option-".concat(order.option.id),
            status: order.place,
            "data-id": "components_MyHouseChoices_Order"
          }, __jsx(OrderContainer, {
            status: order.place,
            "data-id": "components_MyHouseChoices_OrderContainer"
          }, order.place === 'processed' && __jsx(AlertIcon, {
            color: colorPalette.orange,
            "data-id": "components_MyHouseChoices_AlertIcon"
          }), __jsx(OrderTitle, {
            status: order.place,
            "data-id": "components_MyHouseChoices_OrderTitle"
          }, order.option.title, " ", order.amount > 1 && __jsx("span", {
            "data-id": "components_MyHouseChoices_span"
          }, "(", order.amount, "x)")), renderWidth > 689 && __jsx(OrderPrice, {
            "data-id": "components_MyHouseChoices_OrderPrice"
          }, order.salesPrice > 0 ? '+' : order.salesPrice === 0 ? '' : '-', formatPrice(order.salesPrice * order.amount, {
            showDecimal: true,
            showEuroSign: true,
            showNegative: false
          }))), __jsx(OrderStatus, {
            color: colorPalette.green,
            "data-id": "components_MyHouseChoices_OrderStatus"
          }, __jsx("p", {
            "data-id": "components_MyHouseChoices_p"
          }, order.placeDescription, " ", updateDate)), __jsx(OptionSubtitleBase, {
            "data-id": "components_MyHouseChoices_OptionSubtitleBase"
          }, order.option.external_seller && __jsx(ExternalSeller, {
            text: order.option.external_seller,
            extraMarginLeft: true,
            "data-id": "components_MyHouseChoices_ExternalSeller"
          })), __jsx(OptionSubtitleBase, {
            "data-id": "components_MyHouseChoices_OptionSubtitleBase"
          }, order.option.optionCode && __jsx(OrderOptionCode, {
            "data-id": "components_MyHouseChoices_OrderOptionCode"
          }, "Optiecode: ", order.option.optionCode)), renderWidth <= 689 && __jsx(OrderPrice, {
            "data-id": "components_MyHouseChoices_OrderPrice"
          }, formatPrice(order.salesPrice * order.amount, {
            showDecimal: true,
            showEuroSign: true,
            showNegative: false
          })), (order.place === 'requested' || order.place === 'confirmed' || order.place === 'process' || order.place === 'controle' || order.place === 'signed' || order.place === 'presold' || order.place === 'presale') && __jsx(ButtonExpandContainer, {
            "data-id": "components_MyHouseChoices_ButtonExpandContainer"
          }, __jsx(ButtonExpand, {
            label: "Order informatie",
            clickHandler: handleStatus,
            "data-id": "components_MyHouseChoices_ButtonExpand"
          })), order.place === 'processed' && order.option.isConfirmable && __jsx(ButtonContainer, {
            "data-id": "components_MyHouseChoices_ButtonContainer"
          }, __jsx(ButtonPrimary, {
            type: "button",
            size: "small",
            label: "Controleren en bevestigen",
            onClick: handleConfirm,
            "data-id": "components_MyHouseChoices_ButtonPrimary"
          })));
        }), cat.orders && cat.orders.length === 0 && __jsx(Order, {
          "data-id": "components_MyHouseChoices_Order"
        }, __jsx(OrderContainer, {
          "data-id": "components_MyHouseChoices_OrderContainer"
        }, __jsx(OrderTitle, {
          noOption: true,
          "data-id": "components_MyHouseChoices_OrderTitle"
        }, "Geen opties gekozen"))));
      })), __jsx(Footer, {
        "data-id": "components_MyHouseChoices_Footer"
      }, __jsx(WishlistFooter, {
        livingSpace: livingSpace,
        bedrooms: bedrooms,
        myHouseBlock: true,
        smallColumn: true,
        price: totalPrice,
        small: false,
        hasExternalSellers: hasExternalSellers,
        "data-id": "components_MyHouseChoices_WishlistFooter"
      }), hasExternalSellers && __jsx(SellerListContainer, {
        "data-id": "components_MyHouseChoices_SellerListContainer"
      }, houseOverviewTotalPerCompany.map(function (company, index) {
        return __jsx(SellerListItem, {
          key: index,
          "data-id": "components_MyHouseChoices_SellerListItem"
        }, __jsx(SellerListItemLabel, {
          "data-id": "components_MyHouseChoices_SellerListItemLabel"
        }, company.name), __jsx(OrderPrice, {
          "data-id": "components_MyHouseChoices_OrderPrice"
        }, formatPrice(company.salesPrice, {
          showDecimal: true,
          showEuroSign: true,
          showNegative: false
        })));
      })), __jsx(ConfirmedOrdersDownload, {
        url: houseConfirmationExport,
        "data-id": "components_MyHouseChoices_ConfirmedOrdersDownload"
      })));
    }
  }]);
}(PureComponent);
export default withMatch(connect(null, mapDispatchToProps)(MyHouseChoices));
var SellerListContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 10rem;\n"])));
var SellerListItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-top: 1px solid ", ";\n  padding: 10rem 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), colorPalette.lightGrey);
var SellerListItemLabel = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 14rem;\n  color: ", ";\n"])), colorPalette.textGrey);
var MyHouseChoicesContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 980rem;\n  margin: 8rem auto 0;\n  font-family: ", ";\n  background-color: white;\n  padding: 20rem 0 40rem;\n\n  ", ";\n\n  ", ";\n"])), fonts.primary, fromBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 60rem 0;\n  "]))), fromBreakpoint.lg(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 60rem 0;\n  "]))));
var Title = styled.h2(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 32rem;\n  line-height: 38rem;\n  color: ", ";\n  margin: 0rem;\n\n  padding: 0 20rem;\n\n  ", ";\n\n  ", ";\n"])), colorPalette.orange, fromBreakpoint.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin: 0 0 0 30rem;\n    padding: 0 40rem;\n  "]))), fromBreakpoint.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    padding: 0 120rem 0 100rem;\n  "]))));
var Choices = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 16rem;\n  color: ", ";\n\n  ", ";\n"])), colorPalette.textGrey, fromBreakpoint.md(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    margin-top: 24rem;\n  "]))));
var Base = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var CategoryTitleContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0 20rem;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.firstStatus === 'processed' && "margin-bottom: 10rem;";
}, fromBreakpoint.md(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    padding: 0 40rem;\n  "]))), fromBreakpoint.lg(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    padding: 0 120rem 0 100rem;\n  "]))));
var CategoryTitle = styled.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 18rem;\n  padding: 0;\n  margin: 0 0 0 12rem;\n  color: ", ";\n"])), colorPalette.textGrey);
var OrderTitle = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-style: ", ";\n  ", ";\n"])), function (props) {
  return props.noOption ? 'italic' : '';
}, function (props) {
  return props.status === 'processed' && "margin-left: 12rem;";
});
var OrderOptionCode = styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14rem;\n  margin-left: 33rem;\n"])), colorPalette.beige);
var OptionSubtitleBase = styled(OptionSubtitleContainer)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  margin-top: 4px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n"])));
var OrderPrice = styled.p(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  margin: 0;\n\n  ", ";\n"])), toBreakpoint.md(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    margin-left: 33rem;\n    margin-top: 12rem;\n  "]))));
var OrderContainer = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 0 20rem;\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", " {\n    margin-left: auto;\n  }\n\n  > svg {\n    flex-shrink: 0;\n    align-self: flex-start;\n  }\n"])), function (props) {
  return props.status !== 'processed' && "margin-left: 33rem;";
}, fromBreakpoint.md(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    padding: 0 40rem;\n  "]))), fromBreakpoint.lg(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    padding: 0 120rem 0 100rem;\n  "]))), OrderPrice);
var OrderStatus = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  font-size: 14rem;\n  font-style: italic;\n  color: ", ";\n  margin-top: 4px;\n  margin-bottom: 0;\n  margin-left: 33rem;\n\n  > p {\n    margin: 0;\n  }\n"])), function (props) {
  return props.color;
});
var Category = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 20rem;\n"])));
var ButtonContainer = styled.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  margin-top: 20rem;\n  margin-left: 33rem;\n"])));
var Order = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", " {\n    padding: 0;\n  }\n\n  ", " {\n    ", ";\n  }\n"])), function (props) {
  return props.status === 'processed' ? '20rem' : '10rem 20rem';
}, function (props) {
  return props.status === 'processed' && "\n      margin-bottom: 1rem;\n      background-color: rgba(".concat(colorPaletteRGB.loadingOrange, ", 0.25);\n    ");
}, fromBreakpoint.md(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), function (props) {
  return props.status === 'processed' ? '20rem 40rem' : '10rem 40rem';
}), fromBreakpoint.lg(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), function (props) {
  return props.status === 'processed' ? '20rem 120rem 20rem 100rem' : '10rem 120rem 10rem 100rem';
}), OrderContainer, OrderTitle, function (props) {
  return props.status === 'processed' && "\n      font-weight: bold;\n      font-size: 18rem;\n      color: ".concat(colorPalette.orange, ";\n    ");
});
var Footer = styled.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  margin-top: 16rem;\n  padding: 10rem 20rem 0;\n\n  ", ";\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    padding: 10rem 40rem;\n  "]))), fromBreakpoint.lg(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n    padding: 10rem 120rem 10rem 100rem;\n  "]))));
var ButtonExpandContainer = styled.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  margin-left: 33rem;\n"])));